import React, { useState } from 'react'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import './styles.scss'

export const Card = ({ title, subtitle, link }) => {
  return (
    <>
      <div className='ui raised fluid infographic card cardStyle'>
        <div className='content'>
          <p className='heading'>{title}</p>
          <p className='subheading'>{subtitle}</p>
          <AutofitIFrame src={link} style={{ minHeight: '400px' }} />
        </div>
      </div>
    </>
  )
}
